import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import _ from 'lodash'

import style from './style.scss';
import Input from '/chat/src/components/Forms/Input';
import SelectInput from '/chat/src/components/Forms/SelectInput';

import HistoryIcon from '/chat/src/components/SVGImages/History';
import Textarea from '/chat/src/components/Forms/Textarea';
import {TicketModel, SystemModel, CustomizationModel, ConfigModel, UserModel, FeaturesModel} from '/chat/src/redux/model'
import {Validation} from '/chat/src/lib'
import PoweredByJibber from '/chat/src/components/PoweredByJibber';
import StartChattingBody from '../StartChatting/Body';

class OnlineFormular extends Component {
    constructStateFromProps(props){
        return {
            select: [],
            selectValidate: true,
            forms: {
               email: {
                   value: props.user.email,
                   require: props.formsConfig.email.require,
                   visible: props.formsConfig.email.visible,
                   alias: props.formsConfig.email.alias,
                   missing: false,
                   isValidate: true,
                   validate: Validation.validateEmail,
               },
               name: {
                   value: props.user.name,
                   require: props.formsConfig.name.require,
                   visible: props.formsConfig.name.visible,
                   alias: props.formsConfig.name.alias,
                   missing: false,
                   isValidate: true,
                   validate: Validation.validateDummy,
               },
               phone: {
                   value: props.user.phone,
                   require: props.formsConfig.phone.require,
                   visible: props.formsConfig.phone.visible,
                   alias: props.formsConfig.phone.alias,
                   missing: false,
                   isValidate: true,
                   validate: Validation.validateDummy,
               },
               customerRef: {
                   value: props.user.customer_ref,
                   require: props.formsConfig.customer_ref.require,
                   visible: props.formsConfig.customer_ref.visible,
                   alias: props.formsConfig.customer_ref.alias,
                   missing: false,
                   isValidate: true,
                   validate: Validation.validateDummy,
               },
               message: {
                   require: true,
                   visible: false,
                   value: '',
                   missing: false,
                   isValidate: true,
                   validate: Validation.validateDummy,
               }
           }
       }
    }
    constructor(props) {
        super(props);
        this.state = this.constructStateFromProps(props)
        this.handleNewConversationClick = this.handleNewConversationClick.bind(this);
        this.renderForm = this.renderForm.bind(this)
        this.renderExchange = this.renderExchange.bind(this)
    }
    componentWillReceiveProps(nextProps, nextState){
        this.setState(this.constructStateFromProps(nextProps))
    }

    handleNewConversationClick(){
        let missing = false;
        let isValidate = true;
        let newState = {...this.state};
        const {forms, select} = this.state
        let {formsConfig, exchangeAvailable, exchangePayload} = this.props
        for( var form in forms){
            let {value, require, visible} = forms[form]
            let validate = true
            if(!visible) continue;

            if(!value && require){
                newState.forms[form].missing = true
                missing = true
            }else{
                newState.forms[form].missing = false
            }
            if( value && !newState.forms[form].validate(value) ){
                newState.forms[form].isValidate = false
                isValidate = false
            }
        }
        if(exchangeAvailable && exchangePayload.exchange_on){
            if(select.length == 0){
                newState.selectValidate = false
            }
        }

        if(!isValidate || missing){
            this.setState(newState)
            return;
        }
        let payload = {
            'email': forms.email.value,
            'name': forms.name.value,
            'phone': forms.phone.value,
            'customer_ref': forms.customerRef.value
        }
        this.props.dispatch(UserModel.updateUserOnState(payload))
        this.props.dispatch(TicketModel.setCurrentRoom(null))
        this.props.dispatch(TicketModel.setOnlineFormData(payload))
        if(exchangeAvailable && exchangePayload.exchange_on){
            if(select.length > 0){
                const options = exchangePayload.options
                const last = _.last(select)
                this.props.dispatch(TicketModel.setExchangeData({'id': last}))
            }
        }
        this.props.dispatch(SystemModel.setRoute('Chat'));
    }

    renderForm(form, label){
        const obj = this.state.forms[form]
        const require = obj.require
        const visible = obj.visible
        if(visible){
            const value = obj.value
            const missing = obj.missing
            const isValidate = obj.isValidate
            return (
                <div style={{position: 'relative', width: '70%', margin: '15px auto'}}>
                    <Input label={label} value={value}
                        onChange={newValue=>{
                            const newState = {...this.state}
                            newState.forms[form].value = newValue
                            this.setState(newState)
                            }
                        }
                        require={require}
                        missing={missing}
                        isValidate={isValidate}
                     />
                </div>
            )
        }
        return null;
    }

    renderExchange(){
        if(!this.props.exchangeAvailable)
            return null;
        if(!this.props.exchangePayload.exchange_on)
            return null;
        let language = this.props.language

        const options = _.filter(this.props.exchangePayload.options, ['visible', true])

        var values = {'-1': language.get('Others')}
        for(var index in options){
            values[options[index].id] = options[index].label
        }
        var option = _.find(options, (o)=> {return o.id===this.state.select[0]})

        var ChildInput = null;
        var hasChildren = option? _.size(option.children) > 0 : false
        if(hasChildren){
            var childrenValues = { [option.id]: language.get('Others')}
            for(var index in option.children){
                childrenValues[option.children[index].id] = option.children[index].label
            }
            ChildInput = <SelectInput values={childrenValues} onChange={(e)=>{
                    var list = [...this.state.select]
                    list[1] = e.target.value
                    this.setState({select: list})}
                } select={this.state.select[1]}
                label={language.get('SelectTopic')}
                isValidate={this.state.selectValidate}
                />
        }
        return (
            <div style={{position: 'relative', width: '70%', margin: '15px auto'}}>
                <div style={{fontSize: '14px', color: '#404040', margin: '5px 0px'}}>
                    Vad gäller ditt ärende
                </div>
                <SelectInput
                    values={values}
                    onChange={(e)=>{this.setState({select: [e.target.value]})}}
                    select={this.state.select[0]}
                    label={language.get('SelectTopic')}
                    isValidate={this.state.selectValidate}
                />
                {hasChildren && ChildInput}
            </div>
        )
    }

    getRefLabel(alias, language){
        switch(alias){
            case 'ord':
                return language.get('OrderNo.');
            case 'cust':
                return language.get('CustomerNo.');
            case 'ref':
            default:
                return language.get('ReferenceNo.');break;
        }
    }

    render(){
        let formsCount = 0
        const {formsConfig, language, height} = this.props
        for(var forms in formsConfig){
            if(formsConfig[forms].visible){
                formsCount += 1
            }
        }
        if(formsCount == 0){
            //return this._renderStartChattingButton()
            return <StartChattingBody/>
        }

        const paddingTop = '50' - formsCount*10 + 'px'

        const PreviousConversationsButtonProps = {
            title: language.get('ViewPreviousConversation'),
            onClick: ()=>this.props.dispatch(SystemModel.setRoute('Conversations')),
            onMouseOver: ()=>this.setState({historyIconHover: true}),
            onMouseLeave: ()=>this.setState({historyIconHover: false}),
            style: {
                minHeight: '1px',
                float: 'left',
                display: 'inline-block',
                width: '40px',
                cursor: 'pointer',
                paddingTop: '3px',
                paddingRight: '3px'
            }
        }
        let text = language.get("NewConversation");
        const customerRef = this.state.forms.customerRef
        return (
            <div className={style.Body}>
                <div className={style.OnlineFormularBody}>
                    {this.props.formsRequire &&
                    <form style={{paddingTop: paddingTop}}>
                        {this.renderForm('email', language.get('Email'))}
                        {this.renderForm('name', language.get('Name'))}
                        {this.renderForm('phone', language.get('Phone'))}
                        {this.renderForm('customerRef', this.getRefLabel(customerRef.alias, language))}
                    </form>
                    }
                    {this.renderExchange()}
                    <div style={{width: '100%', marginLeft: '20%', marginBottom: '10px'}}>
                        <div  >
                            <div {...PreviousConversationsButtonProps}>
                            {this.props.conversations.size !== 0 && // above is for placeholder, if no img found
                                <HistoryIcon color={this.state.historyIconHover?this.props.color:'#898989'}/>
                            }
                            </div>
                            <div className={style.StartChattingButton} style={{backgroundColor: this.props.color}} onClick={this.handleNewConversationClick}>
                                <span className={style.StartChattingText}> {language.get('NewConversation')} </span>
                            </div>
                        </div>
                    </div>
                </div>
                <PoweredByJibber/>
            </div>
        );
    }

}

function mapStateToProps(state){
    const color = CustomizationModel.getColor(state)
    const language = CustomizationModel.getLanguage(state)
    const conversations = TicketModel.getAll(state)
    const height = SystemModel.getBodyHeight(state)
    const width = SystemModel.getShellWidth(state)
    const formsConfig = CustomizationModel.getFormsConfig(state).toJS()
    const user = UserModel.get(state).toJS()

    const formsRequire = CustomizationModel.getFormsRequire(state)

    const exchangeAvailable = FeaturesModel.getFeatureAvailable(state, 'exchange')
    const exchangePayload = FeaturesModel.getFeaturePayload(state, 'exchange')
    return {
        height, width, formsConfig, user,
        conversations, color, language,

        formsRequire,

        exchangeAvailable, exchangePayload
    };
}

export default connect(mapStateToProps)(OnlineFormular);



// WEBPACK FOOTER //
// ./routes/OnlineFormular/Body.js